import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { routeNode } from 'core/routing';

import { FourOhFour } from 'apps/fourOhFour';
import { MyActivity } from 'apps/home/activityFeed/myActivity';
import { GlobalActivity } from 'apps/home/activityFeed/globalActivity';

const viewsMap = {
  '': MyActivity,
  global: GlobalActivity,
};

@observer
class ActivitySpace extends React.Component {
  render() {
    const View = this.props.componentFromRoute();
    return <View params={this.props.routerStore.params} />;
  }
}

ActivitySpace.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const ActivityRouter = routeNode(
  'home.activity',
  viewsMap,
  FourOhFour,
)(ActivitySpace);
